__turbopack_context__.v({
  "animate-ring1": "_25g0wa_animate-ring1",
  "animate-ring2": "_25g0wa_animate-ring2",
  "animate-ring3": "_25g0wa_animate-ring3",
  "animated-height": "_25g0wa_animated-height",
  "fadeIn": "_25g0wa_fadeIn",
  "history-item-container": "_25g0wa_history-item-container",
  "ringPulse1": "_25g0wa_ringPulse1",
  "ringPulse2": "_25g0wa_ringPulse2",
  "ringPulse3": "_25g0wa_ringPulse3",
  "slide-in": "_25g0wa_slide-in",
  "slide-out": "_25g0wa_slide-out",
  "slideIn": "_25g0wa_slideIn",
  "slideOut": "_25g0wa_slideOut",
  "transition": "_25g0wa_transition",
  "videoAspectRatioContainer": "_25g0wa_videoAspectRatioContainer",
  "videoAspectRatioItem": "_25g0wa_videoAspectRatioItem",
  "videoAspectRatioItemSelected": "_25g0wa_videoAspectRatioItemSelected",
  "videoItemSecondary": "_25g0wa_videoItemSecondary",
  "voices-tab-container": "_25g0wa_voices-tab-container",
  "voices-tab-number": "_25g0wa_voices-tab-number",
  "voices-tab-selected": "_25g0wa_voices-tab-selected",
  "zoom-in": "_25g0wa_zoom-in",
  "zoom-out": "_25g0wa_zoom-out",
  "zoomIn": "_25g0wa_zoomIn",
  "zoomOut": "_25g0wa_zoomOut",
});
